import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d617143"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer-com" }
const _hoisted_2 = { class: "department-wrap" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"sign\" data-v-1d617143> 主办单位：四川省人民政府驻厦门办事处 </div><div class=\"sign\" data-v-1d617143> 地址：福建省厦门市嘉禾路339号四川大厦 513室 </div><div class=\"sign\" data-v-1d617143> 联系电话：0592-8060880 </div><div class=\"sign\" data-v-1d617143> 版权所有：四川省人民政府驻厦门办事处 </div><div class=\"sign\" data-v-1d617143> 备案号：闽ICP备19001842号-1 </div><div class=\"sign\" data-v-1d617143> 主办单位：四川省人民政府驻厦门办事处 </div><div class=\"image-wrap\" data-v-1d617143><img src=\"https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fc-ssl.duitang.com%2Fuploads%2Fitem%2F201611%2F23%2F20161123140823_dnUzC.thumb.400_0.jpeg&amp;refer=http%3A%2F%2Fc-ssl.duitang.com&amp;app=2002&amp;size=f9999,10000&amp;q=a80&amp;n=0&amp;g=0n&amp;fmt=auto?sec=1672764475&amp;t=e863fef40c95f0bc998de723cc806138\" alt=\"\" data-v-1d617143><span data-v-1d617143>微信公众号</span></div>", 7)

import { ref, reactive } from "vue";
import { ElOption, ElSelect } from "element-plus";
import "element-plus/theme-chalk/el-option.css";
import "element-plus/theme-chalk/el-select.css";
import "element-plus/theme-chalk/base.css";

export default /*#__PURE__*/_defineComponent({
  __name: 'footerCom',
  setup(__props) {

const value = ref("");

const options = [
  {
    value: "Option1",
    label: "Option1"
  },
  {
    value: "Option2",
    label: "Option2"
  },
  {
    value: "Option3",
    label: "Option3"
  },
  {
    value: "Option4",
    label: "Option4"
  },
  {
    value: "Option5",
    label: "Option5"
  }
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(ElSelect), {
        class: "select",
        modelValue: value.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
        placement: "top-start",
        placeholder: "Select",
        size: "large"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, (item) => {
            return _createVNode(_unref(ElOption), {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"])
          }), 64))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_unref(ElSelect), {
        class: "select",
        modelValue: value.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((value).value = $event)),
        placement: "top-start",
        placeholder: "Select",
        size: "large"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, (item) => {
            return _createVNode(_unref(ElOption), {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"])
          }), 64))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_unref(ElSelect), {
        class: "select",
        modelValue: value.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((value).value = $event)),
        placement: "top-start",
        placeholder: "Select",
        size: "large"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, (item) => {
            return _createVNode(_unref(ElOption), {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"])
          }), 64))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_unref(ElSelect), {
        class: "select",
        modelValue: value.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((value).value = $event)),
        placement: "top-start",
        placeholder: "Select",
        size: "large"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, (item) => {
            return _createVNode(_unref(ElOption), {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"])
          }), 64))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _hoisted_3
  ]))
}
}

})